export interface Video {
  id: string;
  title: string;
  description: string;
  creator: string;
  url: string;
  views: string;
  music: string;
  isTrending: boolean;
  isPartnered: boolean;
}

export const MOCK_VIDEOS: Video[] = [
  {
    id: '1',
    title: 'Sample Video 1',
    description: 'This is a sample video description',
    creator: 'Creator1',
    url: 'https://videos.openai.com/vg-assets/assets%2Ftask_01jgqyz97kf6mt6nqeyx6qqadr%2Ftask_01jgqyz97kf6mt6nqeyx6qqadr_genid_03e7154c-96ed-4ce4-aa29-aea75f73556c_25_01_04_06_10_971883%2Fvideos%2F00000_904082%2Fsource.mp4?st=2025-01-04T06%3A43%3A33Z&se=2025-01-10T07%3A43%3A33Z&sks=b&skt=2025-01-04T06%3A43%3A33Z&ske=2025-01-10T07%3A43%3A33Z&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skoid=8ebb0df1-a278-4e2e-9c20-f2d373479b3a&skv=2019-02-02&sv=2018-11-09&sr=b&sp=r&spr=https%2Chttp&sig=BzvDeIq770onS28mA%2BZEx%2BxrvtyYVZuI7tj5beW3dj4%3D&az=oaivgprodscus',
    views: '10k',
    music: 'Sample Music Track',
    isTrending: true,
    isPartnered: false
  },
  {
    id: '2',
    title: 'Sample Video 2',
    description: 'Another sample video description',
    creator: 'Creator2',
    url: 'https://videos.openai.com/vg-assets/assets%2Ftask_01jgqyz97kf6mt6nqeyx6qqadr%2Ftask_01jgqyz97kf6mt6nqeyx6qqadr_genid_03e7154c-96ed-4ce4-aa29-aea75f73556c_25_01_04_06_10_971883%2Fvideos%2F00000_904082%2Fsource.mp4?st=2025-01-04T06%3A43%3A33Z&se=2025-01-10T07%3A43%3A33Z&sks=b&skt=2025-01-04T06%3A43%3A33Z&ske=2025-01-10T07%3A43%3A33Z&sktid=a48cca56-e6da-484e-a814-9c849652bcb3&skoid=8ebb0df1-a278-4e2e-9c20-f2d373479b3a&skv=2019-02-02&sv=2018-11-09&sr=b&sp=r&spr=https%2Chttp&sig=BzvDeIq770onS28mA%2BZEx%2BxrvtyYVZuI7tj5beW3dj4%3D&az=oaivgprodscus',
    views: '5k',
    music: 'Another Music Track',
    isTrending: false,
    isPartnered: true
  }
];